<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template>
            <el-input clearable v-model="search.name" class="input_search" placeholder="搜索课程名称"
              style="margin-bottom: 10px;margin-right: 10px" @keyup.enter.native="SearchServiceList"></el-input>

            <el-select v-model="search.categoryId" clearable filterable placeholder="选择分类"
              style="margin-bottom: 10px;margin-right: 10px">
              <el-option-group v-for="group in groupedCategoryOptions" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>

            <el-select v-model="search.isOffline" clearable filterable placeholder="课程状态"
              style="margin-bottom: 10px;margin-right: 10px">
              <el-option v-for="item in COURSE_STATUS" :key="item.key" :label="item.name" :value="item.key"></el-option>
            </el-select>

            <el-select v-model="search.isRecommend" clearable filterable placeholder="推荐状态"
              style="margin-bottom: 10px;margin-right: 10px">
              <el-option v-for="item in RECOMMEND_STATUS" :key="item.key" :label="item.name"
                :value="item.key"></el-option>
            </el-select>

            <el-button size="medium" type="primary" @click="SearchServiceList">查询</el-button>
            <el-button size="medium" @click="handleReset">重置</el-button>
          </template>
          <el-button v-if="addShow" size="medium" type="primary" @click="handleAdd">新增课程</el-button>
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table :data="tableData" size="medium" border style="width: 100%" v-loading="loading">
            <el-table-column fixed label="序号" type="index" width="80">
              <template slot-scope="scope">
                <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column label="课程信息" min-width="250">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; text-align: left;">
                  <div style="width: 60px; height: 60px; margin-right: 10px; flex-shrink: 0;">
                    <img :src="scope.row.listImage1"
                      style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;" />
                  </div>
                  <div style="flex: 1;">
                    <div style="font-weight: bold; font-size: 14px; margin-bottom: 5px;">
                      {{ scope.row.name || '-' }}
                    </div>
                    <div style="color: #666; font-size: 12px; margin-bottom: 3px;">
                      ID：{{ scope.row.id || '-' }} | 作者：{{ scope.row.author || '-' }}
                    </div>
                    <div style="color: #666; font-size: 12px;">
                      {{ scope.row.description || '-' }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="分类信息" width="140">
              <template slot-scope="scope">
                <div style="text-align: left;">
                  <div style="font-size: 12px; margin-bottom: 2px;">
                    父级：{{ scope.row.parentCategoryName || '-' }}
                  </div>
                  <div style="font-size: 12px; font-weight: bold;">
                    分类：{{ scope.row.categoryName || '-' }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="课程形式" width="100">
              <template slot-scope="scope">
                <el-tag :type="getCourseFormatTag(scope.row.format)" size="mini">
                  {{ getCourseFormatText(scope.row.format) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="价格信息" width="120">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <div style="color: #f56c6c; font-weight: bold; font-size: 14px;">
                    ¥{{ formatPrice(scope.row.discountPrice) }}
                  </div>
                  <div style="color: #999; font-size: 12px; text-decoration: line-through;"
                    v-if="scope.row.originalPrice !== scope.row.discountPrice">
                    ¥{{ formatPrice(scope.row.originalPrice) }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="学习数据" width="120">
              <template slot-scope="scope">
                <div style="font-size: 12px; text-align: center;">
                  <div>学习人数：{{ scope.row.uvCount || 0 }}</div>
                  <div>学习次数：{{ scope.row.pvCount || 0 }}</div>
                  <div>购买人数：{{ scope.row.displayPurchaseCount || 0 }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="课程统计" width="120">
              <template slot-scope="scope">
                <div style="font-size: 12px; text-align: center;">
                  <div>页数：{{ scope.row.pageCount || 0 }}</div>
                  <div>章节：{{ scope.row.chapterCount || 0 }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isOffline === 0 ? 'success' : 'danger'" size="mini">
                  {{ scope.row.isOffline === 0 ? '上架' : '下架' }}
                </el-tag>
                <el-tag :type="scope.row.isRecommend === 0 ? 'info' : 'primary'" size="mini">
                  {{ scope.row.isRecommend === 0 ? '普通' : '推荐' }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="排序" width="100" align="center">
              <template slot-scope="scope">
                <InlineTableControler v-model="scope.row.sortOrder" type="number" valueKey="sortOrder"
                  customApi="/course/info/save" :disabled="!editShow" :params="getRowEditParams(scope.row)"
                  @refresh="getCourseList" />
              </template>
            </el-table-column>

            <el-table-column label="上架" width="80" align="center">
              <template slot-scope="scope">
                <InlineTableControler v-model="scope.row.isOffline" valueKey="isOffline" customApi="/course/info/save"
                  :active-value="0" :inactive-value="1" activeColor="#13ce66" inactiveColor="#ff4949"
                  :disabled="!statusShow" :params="getRowEditParams(scope.row)" @refresh="getCourseList" />
              </template>
            </el-table-column>

            <el-table-column label="推荐" width="80" align="center">
              <template slot-scope="scope">
                <InlineTableControler v-model="scope.row.isRecommend" valueKey="isRecommend"
                  customApi="/course/info/save" :disabled="!statusShow" :params="getRowEditParams(scope.row)"
                  @refresh="getCourseList" />
              </template>
            </el-table-column>

            <el-table-column label="时间信息" min-width="200">
              <template slot-scope="scope">
                <div style="font-size: 12px;">
                  <div>创建：{{ formatDate(scope.row.ctime) }}</div>
                  <div>更新：{{ formatDate(scope.row.utime) }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row)" type="text" size="small" v-if="editShow">
                  编辑
                </el-button>

                <el-button @click="handleDelete(scope.row)" type="text" size="small" style="color: #f56c6c"
                  v-if="deleteShow">
                  删除
                </el-button>

                <el-button @click="handleDetail(scope.row)" type="text" size="small" v-if="detailShow">
                  详情
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="page.pageNo" :page-sizes="[PAGE_SIZE, 15, 20, 25]" :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="page.count">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <MultiLanguageEditDialog inline :fullscreen="true" ref="editDialog" title="课程编辑" :api="'/course/info/save'"
      :detail-api-template="'/course/info/detail/{id}'" :multi-language-fields="['name', 'description']"
      @success="getCourseList" @close="getCourseList" />

    <!-- 详情弹窗 -->
    <MultiLanguageDetailDialog :fullscreen="true" ref="detailDialog" title="课程详情"
      :detail-api-template="'/course/info/detail/{id}'" :multi-language-fields="['name', 'description']" />
  </section>
</template>
<script>
import {
  PAGE_SIZE,
} from "@/config";
import { formatDate, formatPrice } from "@/utils/filters/filter";
import MultiLanguageEditDialog from '@/components/MultiLanguageEditDialog.vue';
import MultiLanguageDetailDialog from '@/components/MultiLanguageDetailDialog.vue';
import InlineTableControler from '@/components/InlineTableControler.vue';
export default {
  components: {
    MultiLanguageEditDialog,
    MultiLanguageDetailDialog,
    InlineTableControler
  },
  data() {
    return {
      PAGE_SIZE,
      formatDate,

      // 课程状态选项
      COURSE_STATUS: [
        { key: 0, name: '上架' },
        { key: 1, name: '下架' }
      ],

      // 推荐状态选项
      RECOMMEND_STATUS: [
        { key: 0, name: '普通' },
        { key: 1, name: '推荐' }
      ],

      // 课程形式选项
      COURSE_FORMAT: [
        { key: 1, name: 'PDF' },
        { key: 2, name: 'Word' },
        { key: 3, name: '音频' },
        { key: 4, name: '视频' }
      ],

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
        count: 0
      },

      categoryList: [], // 分类列表
      parentCategoryList: [], // 父级分类列表
      tableData: [], // 课程列表数据
      loading: false,
      search: {},

      // 权限控制
      searchShow: true,
      addShow: true,
      editShow: true,
      deleteShow: true,
      statusShow: true,
      detailShow: true,

      // 多语言相关
      languageList: [],
      currentLanguageCode: 'en'
    };
  },
  created() {
    this.getCategoryList();
    this.getCourseList();
    this.getPermissionButtonList();
    this.getLanguageList();
  },
  computed: {
    groupedCategoryOptions() {
      const list = Array.isArray(this.categoryList) ? this.categoryList : [];
      // 只取父级
      const parents = list.filter(cat => !cat.parentId || cat.parentId === 0);
      return parents.map(parent => {
        // 该父级下的所有子级
        const subOptions = list
          .filter(child => child.parentId === parent.id)
          .map(child => ({
            value: Number(child.id),
            label: String(child.name)
          }));
        // 父级本身也可选，放在分组最前面
        return {
          label: String(parent.name),
          options: [
            ...subOptions
          ]
        };
      });
    },
  },
  watch: {
    groupedCategoryOptions: {
      handler(newVal) {
        console.log('groupedCategoryOptions', newVal)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getRowEditParams(row) {
      return {
        ...row,
        // 价格转换：人民币元 -> 美元分
        price: Math.round(row.price * 100 / 6.8)
      };
    },
    // 获取分类列表
    async getCategoryList() {
      try {
        const { data: res } = await this.$post(
          `/course/category/list`,
          {
            pageNo: 1,
            pageSize: 1000
          }
        );
        if (res && res.data) {
          this.categoryList = res.data; // 直接赋值为data数组
          console.log('categoryList', this.categoryList)
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
      }
    },

    // 获取语言列表
    async getLanguageList() {
      try {
        const { data: res } = await this.$post('/language/list', {
          adminStatus: 1
        });

        if (res && res.data) {
          this.languageList = res.data;
          this.currentLanguageCode = (res.data[0] && res.data[0].code) || 'en';
        }
      } catch (error) {
        console.error('获取语言列表失败:', error);
      }
    },

    // 获取权限按钮列表
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton');
      if (PermissionButtonList) {
        try {
          let arr = JSON.parse(PermissionButtonList);
          // 确保arr是数组并且有内容
          if (Array.isArray(arr) && arr.length > 0) {
            arr.forEach(item => {
              if (item.code === 'course:management:query') {
                this.searchShow = true;
              }
              if (item.code === 'course:management:add') {
                this.addShow = true;
              }
              if (item.code === 'course:management:edit') {
                this.editShow = true;
              }
              if (item.code === 'course:management:delete') {
                this.deleteShow = true;
              }
              if (item.code === 'course:management:status') {
                this.statusShow = true;
              }
              if (item.code === 'course:management:detail') {
                this.detailShow = true;
              }
            });
          }
        } catch (error) {
          console.error('权限按钮列表解析失败:', error);
        }
      }
    },

    // 搜索
    SearchServiceList() {
      this.page.pageNo = 1;
      this.getCourseList();
    },

    // 获取课程列表
    async getCourseList() {
      this.loading = true;
      try {
        const { data: res } = await this.$post(
          `/course/info/list`,
          {
            ...this.search,
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize
          },
          {
            headers: {
              isLoading: true,
            },
          }
        );

        if (res && res.data) {
          this.tableData = res.data.records || res.data||[];
          this.page.count = res.page.count || 0;
        }else{
          this.tableData = [];
          this.page.count = 0;
        }
      } catch (error) {
        console.error('获取课程列表失败:', error);
        this.$message.error('获取课程列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 新增课程
    handleAdd() {
      if (!this.$refs.editDialog) return;

      this.$refs.editDialog.open({}, this.getBasicColumns(), {
        api: '/course/info/save',
        method: 'post',
        enableMultiLanguage: true,
        languageList: this.languageList
      });
    },

    // 编辑课程
    async handleEdit(row) {
      if (!this.$refs.editDialog) return;

      // 确保编辑数据包含正确的字段
      const editData = {
        ...row,
        // 确保分类ID存在，如果没有则尝试从分类列表中查找
        categoryId: row.categoryId || this.getCategoryIdByName(row.categoryName),
        // 确保父级分类ID存在
        parentCategoryId: row.parentCategoryId || this.getParentCategoryIdByName(row.parentCategoryName)
      };

      console.log('编辑数据:', editData);

      this.$refs.editDialog.open(editData, this.getBasicColumns(), {
        api: '/course/info/save',
        method: 'post',
        enableMultiLanguage: true,
        languageList: this.languageList
      });
    },

    // 根据分类名称获取分类ID
    getCategoryIdByName(categoryName) {
      if (!categoryName || !this.categoryList) return null;
      const category = this.categoryList.find(cat => cat.name === categoryName);
      return category ? category.id : null;
    },

    // 根据父级分类名称获取父级分类ID
    getParentCategoryIdByName(parentCategoryName) {
      if (!parentCategoryName || !this.parentCategoryList) return null;
      const parentCategory = this.parentCategoryList.find(cat => cat.name === parentCategoryName);
      return parentCategory ? parentCategory.id : null;
    },

    // 查看详情
    async handleDetail(row) {
      // 检查ref是否存在
      if (!this.$refs.detailDialog) {
        console.error('DetailDialog组件未找到');
        this.$message.error('详情组件加载失败，请刷新页面重试');
        return;
      }

      // 定义课程基础信息列配置
      const basicColumns = [
        { label: '课程ID', prop: 'id', type: 'text' },
        { label: '课程名称', prop: 'name', type: 'text', span: 2 },
        { label: '作者', prop: 'author', type: 'text' },
        { label: '课程简介', prop: 'description', type: 'text', span: 2 },
        { label: '父级分类', prop: 'parentCategoryName', type: 'text' },
        { label: '分类', prop: 'categoryName', type: 'text' },
        {
          label: '课程形式', prop: 'format', type: 'tag', tagMap: {
            1: { text: 'PDF', type: 'primary' },
            2: { text: 'Word', type: 'success' },
            3: { text: '音频', type: 'warning' },
            4: { text: '视频', type: 'danger' }
          }
        },
        { label: '轮播图', prop: 'slideshowImages', type: 'images' },
        { label: '列表图1', prop: 'listImage1', type: 'image' },
        { label: '列表图2', prop: 'listImage2', type: 'image' },
        { label: '视频', prop: 'video', type: 'video' },
        { label: '附件', prop: 'accessoryUrl', type: 'file' },
        { label: '页数', prop: 'pageCount', type: 'text' },
        { label: '章节数', prop: 'chapterCount', type: 'text' },
        { label: '原价', prop: 'originalPrice', type: 'text', format: (val) => `$${this.formatPrice(val)}` },
        { label: '折扣价', prop: 'discountPrice', type: 'text', format: (val) => `$${this.formatPrice(val)}` },
        { label: '学习人数', prop: 'uvCount', type: 'text' },
        { label: '学习次数', prop: 'pvCount', type: 'text' },
        { label: '真实购买人数', prop: 'realPurchaseCount', type: 'text' },
        { label: '展示购买人数', prop: 'displayPurchaseCount', type: 'text' },
        { label: '学习人数', prop: 'uvCount', type: 'text' },
        {
          label: '是否新品', prop: 'isNew', type: 'tag', tagMap: {
            0: { text: '否', type: 'info' },
            1: { text: '是', type: 'danger' }
          }
        },
        { label: '排序', prop: 'sortOrder', type: 'text' },
        {
          label: '状态', prop: 'isOffline', type: 'tag', tagMap: {
            0: { text: '上架', type: 'success' },
            1: { text: '下架', type: 'danger' }
          }
        },
        {
          label: '推荐状态', prop: 'isRecommend', type: 'tag', tagMap: {
            0: { text: '普通', type: 'info' },
            1: { text: '推荐', type: 'warning' }
          }
        },
        { label: '上架时间', prop: 'publishTime', type: 'date' },
        { label: '创建时间', prop: 'ctime', type: 'date' },
        { label: '更新时间', prop: 'utime', type: 'date' },
      ];

      // 构建选项卡数据
      const tabsData = [
        {
          label: '基础信息',
          name: 'basic',
          columns: basicColumns,
          data: row
        }
      ];

      this.$refs.detailDialog.openWithMultiLanguage(tabsData, {
        enableMultiLanguage: true,
        languageList: this.languageList,
        originalData: row
      });
    },

    // 删除课程
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这门课程吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 调用删除接口
        await this.$get(`/course/info/delete/${row.id}`);
        this.$message.success('删除成功');
        this.getCourseList();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },
    // 分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getCourseList();
    },

    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getCourseList();
    },

    // 获取课程形式标签颜色
    getCourseFormatTag(format) {
      const tagMap = {
        1: 'primary',  // PDF
        2: 'success',  // Word
        3: 'warning',  // 音频
        4: 'danger'    // 视频
      };
      return tagMap[format] || '';
    },

    // 获取课程形式文本
    getCourseFormatText(format) {
      const textMap = {
        1: 'PDF',
        2: 'Word',
        3: '音频',
        4: '视频'
      };
      return textMap[format] || format;
    },

    // 格式化价格（美元分转元）
    formatPrice(price) {
      if (!price) return '0.00';
      return (price / 100).toFixed(2);
    },

    // 图片加载失败处理
    handleImageError(e) {
      e.target.src = '/default-course.jpg';
    },

    // 重置搜索条件
    handleReset() {
      this.search = {};
      this.page.pageNo = 1;
      this.getCourseList();
    },

    // 获取统一的字段配置
    getAllColumns() {
      return [
        {
          label: '课程名称',
          prop: 'name',
          type: 'text',
          required: true,
          detailType: 'text'
        },
        {
          label: '作者',
          prop: 'author',
          type: 'text',
          detailType: 'text'
        },
        {
          label: '课程简介',
          prop: 'description',
          type: 'textarea',
          detailType: 'text'
        },
        // {
        //   label: '父级分类',
        //   prop: 'parentCategoryId',
        //   type: 'select',
        //   options: this.parentCategoryList,
        //   detailType: 'text',
        //   detailProp: 'parentCategoryName'
        // },
        {
          label: '分类',
          prop: 'categoryId',
          type: 'groupSelect',
          options: this.groupedCategoryOptions,
          required: true,
          detailType: 'text',
          detailProp: 'categoryName'
        },
        {
          label: '轮播图',
          prop: 'slideshowImages',
          type: 'images',
          limit: 5,
          maxSize: 2,
          detailType: 'images'
        },
        {
          label: '页数',
          prop: 'pageCount',
          type: 'number',
          detailType: 'text'
        },
        {
          label: '章节数',
          prop: 'chapterCount',
          type: 'number',
          detailType: 'text'
        },
        {
          label: '附件',
          prop: 'accessoryUrl',
          type: 'file',
          maxSize: 50,
          acceptTypes: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip', 'rar'],
          detailType: 'file'
        },
        {
          label: '列表图1',
          prop: 'listImage1',
          type: 'image',
          detailType: 'image'
        },
        {
          label: '列表图2',
          prop: 'listImage2',
          type: 'image',
          detailType: 'image'
        },
        {
          label: '视频',
          prop: 'video',
          type: 'video',
          maxSize: 500,
          acceptTypes: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'],
          detailType: 'video'
        },
        {
          label: '原价(美元分)',
          prop: 'originalPrice',
          type: 'number',
          placeholder: '请输入价格，单位为美元分',
          required: true,
          detailType: 'text',
          detailLabel: '原价',
          format: (val) => `¥${this.formatPrice(val)}`
        },
        {
          label: '折扣价(美元分)',
          prop: 'discountPrice',
          type: 'number',
          placeholder: '请输入价格，单位为美元分',
          required: true,
          detailType: 'text',
          detailLabel: '折扣价',
          format: (val) => `¥${this.formatPrice(val)}`
        },
        {
          label: '学习人数',
          prop: 'uvCount',
          type: 'number',
          addHide: true,
          editHide: true,
          detailType: 'text'
        },
        {
          label: '学习次数',
          prop: 'pvCount',
          type: 'number',
          addHide: true,
          editHide: true,
          detailType: 'text'
        },
        {
          label: '真实购买人数',
          prop: 'realPurchaseCount',
          type: 'number',
          addHide: true,
          editHide: true,
          detailType: 'text'
        },
        {
          label: '展示购买人数',
          prop: 'displayPurchaseCount',
          type: 'number',
          detailType: 'text'
        },
        {
          label: '学习人数',
          prop: 'uvCount',
          type: 'number',
          detailType: 'text'
        },
        {
          label: '是否新品',
          prop: 'isNew',
          type: 'switch',
          detailType: 'tag',
          tagMap: { 0: { text: '否', type: 'info' }, 1: { text: '是', type: 'danger' } }
        },
        {
          label: '排序',
          prop: 'sortOrder',
          type: 'number',
          detailType: 'text'
        },
        {
          label: '上架时间',
          prop: 'publishTime',
          type: 'date',
          detailType: 'date'
        },
        {
          label: '是否下架',
          prop: 'isOffline',
          type: 'switch',
          detailType: 'tag',
          tagMap: { 0: { text: '上架', type: 'success' }, 1: { text: '下架', type: 'danger' } }
        },
        {
          label: '是否推荐',
          prop: 'isRecommend',
          type: 'switch',
          detailType: 'tag',
          tagMap: { 0: { text: '普通', type: 'info' }, 1: { text: '推荐', type: 'warning' } }
        },
        {
          label: '课程形式',
          prop: 'format',
          type: 'select',
          options: this.COURSE_FORMAT,
          required: true,
          detailType: 'tag',
          tagMap: { 1: { text: 'PDF', type: 'primary' }, 2: { text: 'Word', type: 'success' }, 3: { text: '音频', type: 'warning' }, 4: { text: '视频', type: 'danger' } }
        },
        {
          label: '创建时间',
          prop: 'ctime',
          type: 'date',
          addHide: true,
          editHide: true,
          detailType: 'date'
        },
        {
          label: '更新时间',
          prop: 'utime',
          type: 'date',
          addHide: true,
          editHide: true,
          detailType: 'date'
        }
      ];
    },

    getBasicColumns() {
      return [
        {
          label: '课程名称',
          prop: 'name',
          type: 'text',
          required: true,
          multiLanguage: true
        },

        {
          label: '分类',
          prop: 'categoryId',
          type: 'groupSelect',
          options: this.groupedCategoryOptions,
          required: true
        },
        {
          label: '课程形式',
          prop: 'format',
          type: 'select',
          options: this.COURSE_FORMAT,
          required: true
        },
        {
          label: '作者',
          prop: 'author',
          type: 'text'
        },
        {
          label: '页数',
          prop: 'pageCount',
          type: 'number'
        },
        {
          label: '章节数',
          prop: 'chapterCount',
          type: 'number'
        },
        {
          label: '原价(美元分)',
          prop: 'originalPrice',
          type: 'number',
          placeholder: '请输入价格，单位为美元分',
          required: true
        },
        {
          label: '折扣价(美元分)',
          prop: 'discountPrice',
          type: 'number',
          placeholder: '请输入价格，单位为美元分',
          required: true
        },
        {
          label: '学习人数',
          prop: 'uvCount',
          type: 'number',
          addHide: true,
          editHide: true
        },
        {
          label: '学习次数',
          prop: 'pvCount',
          type: 'number',
          addHide: true,
          editHide: true
        },
        {
          label: '真实购买人数',
          prop: 'realPurchaseCount',
          type: 'number',
          addHide: true,
          editHide: true
        },
        {
          label: '展示购买人数',
          prop: 'displayPurchaseCount',
          type: 'number'
        },
        {
          label: '学习人数',
          prop: 'uvCount',
          type: 'number',
        },
        {
          label: '是否新品',
          prop: 'isNew',
          type: 'switch'
        },
        {
          label: '排序',
          prop: 'sortOrder',
          type: 'number'
        },
        {
          label: '上架时间',
          prop: 'publishTime',
          type: 'date'
        },
        {
          label: '是否下架',
          prop: 'isOffline',
          type: 'switch'
        },
        {
          label: '是否推荐',
          prop: 'isRecommend',
          type: 'switch'
        },



        {
          label: '附件',
          prop: 'accessoryUrl',
          type: 'file',
          maxSize: 50,
          acceptTypes: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip', 'rar']
        },

        {
          label: '轮播图',
          prop: 'slideshowImages',
          type: 'images',
          limit: 5,
          maxSize: 2
        },

        {
          label: '列表图1',
          prop: 'listImage1',
          type: 'image'
        },
        {
          label: '列表图2',
          prop: 'listImage2',
          type: 'image'
        },
        {
          label: '视频',
          prop: 'video',
          type: 'video',
          maxSize: 500,
          acceptTypes: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv']
        },
        {
          label: '课程简介',
          prop: 'description',
          type: 'richText',
          span:3,
        },
        {
          label: '创建时间',
          prop: 'ctime',
          type: 'date',
          addHide: true,
          editHide: true
        },
        {
          label: '更新时间',
          prop: 'utime',
          type: 'date',
          addHide: true,
          editHide: true
        }
      ];
    },

    // 获取详情显示的列配置
    getDetailColumns() {
      return this.getAllColumns().map(col => ({
        label: col.detailLabel || col.label,
        prop: col.detailProp || col.prop,
        type: col.detailType || col.type,
        tagMap: col.tagMap,
        format: col.format
      }));
    },

  },
  watch: {
    groupedCategoryOptions: {
      handler(newVal) {
        console.log('groupedCategoryOptions', newVal)
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666;
  /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>